export default {"src":"/_next/static/media/prideBet-testimonial.3d9559cc.svg","height":25,"width":98,"blurWidth":0,"blurHeight":0};